import config from 'configs/app';

export async function ymAsync(target: string, params?: object): Promise<void> {
  const ymCounterId = config.ymCounterId;
  const ymAction = config.ymAction;
  try {
    new Promise<void>((resolve) => {
      // eslint-disable-next-line no-console
      console.log('Sending YM event:', target, params);

      ym(ymCounterId, ymAction, target, params, () => {
        resolve();
      });
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('YM tracking failed:', error);
  }
}
